// 🧭 useHeaderLogic.js
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import authApi from '../api/authApi';
import profilApi from '../api/profilApi';
import chatApi from '../api/chatApi';
import { setDialogs, setDialogId, setDialogName } from '../components/ChatApp/chatSlice';
import { selectUserId, selectUserEmail } from '../components/Login/loginSlice';

export const useDialog = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = useSelector(selectUserId);
  const userEmail = useSelector(selectUserEmail);

  /** 🔑 Выход из системы */
  const handleLogout = async () => {
    try {
      await authApi.logout();
      localStorage.clear();
      navigate('/login');
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }
  };

  /** 👤 Получение данных пользователя */
  const fetchUserData = async () => {
    try {
      const response = await profilApi.fetchUserData(userEmail);
      return response.data;
    } catch (error) {
      console.error('Ошибка при загрузке профиля:', error);
      return null;
    }
  };

  /** 💬 Загрузка всех диалогов */
  const fetchDialogs = async () => {
    try {
      const res = await chatApi.getUserDialogs(userId);
      dispatch(setDialogs(res.data.dialogs));
    } catch (err) {
      console.error('Ошибка загрузки диалогов:', err);
    }
  };

  /** 💬 Создание нового диалога */
  const handleNewDialog = async () => {
    try {
      const res = await chatApi.startNewDialog(userId);
      dispatch(setDialogId(res.data.dialogId));
      dispatch(setDialogName('Новый диалог'));
      fetchDialogs();
      navigate('/chat');
    } catch (err) {
      console.error('Ошибка при создании нового диалога:', err);
    }
  };

  return {
    handleLogout,
    fetchUserData,
    fetchDialogs,
    handleNewDialog,
  };
};
